<script>
  import Landing from "./lib/Landing.svelte";
  import Account from "./lib/Account.svelte";
  import PinLogin from "./lib/PinLogin.svelte";
  import PinUpdate from "./lib/PinUpdate.svelte";
  import VoucherRedemption from "./lib/VoucherRedemption.svelte";
  import BundlePurchase from "./lib/BundlePurchase.svelte";
  import Help from "./lib/Help.svelte";
  import LoadingIndicator from "./lib/components/LoadingIndicator.svelte";

  import { onMount } from "svelte";
  import { createStore } from "./lib/store.svelte.js";

  let store = createStore();

  function disableBackButton() {
    history.pushState(null, null, location.href);
    window.onpopstate = function (event) {
      history.pushState(null, null, location.href);
    };
  }

  onMount(() => {
    disableBackButton();
  });
</script>

<main
  class="h-screen max-w-screen-md m-auto flex justify-center items-center relative"
>
  {#if store.loadingIndicator}
    <div class="w-full absolute top-0">
      <LoadingIndicator />
    </div>
  {/if}

  {#if store.state === "LANDING"}
    <Landing {store} />
  {:else if store.state === "ACCOUNT"}
    <Account {store} />
  {:else if store.state === "PIN_LOGIN"}
    <PinLogin {store} />
  {:else if store.state === "PIN_UPDATE"}
    <PinUpdate {store} />
  {:else if store.state === "VOUCHER_REDEMPTION"}
    <VoucherRedemption {store} />
  {:else if store.state === "BUNDLE_PURCHASE"}
    <BundlePurchase {store} />
  {:else if store.state === "HELP"}
    <Help {store} />
  {/if}
</main>
